module.exports = __webpack_public_path__ + "static/alex-grad-1-f9e42696f4cb69a1b0ac926485187967.jpg";